import { Component, Input, NgZone } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Subscription } from 'rxjs';
import { ImpersonationService } from 'src/app/auth/apigee/impersonation.service';
import { ApigeeService } from 'src/app/auth/apigee/apigee.service';
import { Router } from '@angular/router';

@Component({
  selector: 'user-info',
  templateUrl: './userInfo.component.html',
  styleUrls: ['./userInfo.component.css'],
  animations: [
    trigger('zoomout', [
      state('true', style({ "transform": "scale(0.75)", "transform-origin": "center center", "opacity": "0.5" })),
      state('false', style({ "transform": "scale(1)", "transform-origin": "center center", "opacity": "1" })),
      transition('true => false', animate('500ms ease-in')),
      transition('false => true', animate('500ms ease-out'))
    ]),
    trigger('zoomin', [
      state('true', style({ "transform": "scale(1)", "transform-origin": "center center", "opacity": "1" })),
      state('false', style({ "transform": "scale(1)", "transform-origin": "center center", "opacity": "1" })),
      transition('true => false', animate('500ms ease-in')),
      transition('false => true', animate('500ms ease-out'))
    ])
  ],
  standalone: false
})
export class UserInfoComponent {

  private authTokensUpdated: Subscription;
  private impersonationAuthTokensUpdated: Subscription;
  private mAvatarUrl: string;
  private mImpersonatedAvatarUrl: string;

  @Input() public enableImpersonation: boolean = false;

  constructor(private apigeeService: ApigeeService,
    private router: Router,
    private zone: NgZone,
    private impersonationService: ImpersonationService,
    public sanitizer: DomSanitizer) {

  }

  public get visible(): boolean {
    return this.apigeeService.hasToken;
  }

  public get avatarUrl(): string {
    return this.mAvatarUrl;
  }

  public get isImpersonating(): boolean {
    return this.impersonationService.isImpersonating;
  }

  public get impersonatedAvatarUrl(): string {
    return this.mImpersonatedAvatarUrl;
  }

  private setAvatarImage(imageUrl: string): void {
    this.mAvatarUrl = imageUrl;
  }

  private setImpersonatedAvatarImage(imageUrl: string): void {
    this.mImpersonatedAvatarUrl = imageUrl;
  }

  public ngOnInit(): void {
    this.authTokensUpdated = this.apigeeService.authTokensUpdated.subscribe(() => this.setAvatarImage(this.apigeeService.getProfileImage()));
    this.impersonationAuthTokensUpdated = this.impersonationService.impersonationChanged.subscribe(() => {
      if (this.impersonationService.isImpersonating) {
        this.setImpersonatedAvatarImage(this.impersonationService.getProfileImage())
      } else {
        setTimeout(() => this.setImpersonatedAvatarImage(null), 500);
      }
    });
    this.setAvatarImage(this.impersonationService.getProfileImage());
  }

  public ngOnDestroy(): void {
    if (this.authTokensUpdated) this.authTokensUpdated.unsubscribe();
    if (this.impersonationAuthTokensUpdated) this.impersonationAuthTokensUpdated.unsubscribe();
  }

  public logout(event: Event): void {
    if (event)  {
      event.stopPropagation();
    }

    this.apigeeService.revokeToken().subscribe({
      next: () => this.zone.run(() => this.router.navigate(['login'])),
      error: () => this.zone.run(() => this.router.navigate(['login']))
    });
  }
}
